import Vara1 from '../Navara/Vara (1).webp'
import Vara2 from '../Navara/Vara (2).webp'




const Varaimages =[
Vara1,Vara2
]

export default Varaimages;